"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var __1 = require("../");
function useSignOut() {
    var signOut = (0, react_1.useContext)(__1.AuthenticatorContext).signOut;
    return signOut;
}
exports.default = useSignOut;
//# sourceMappingURL=useSignOut.js.map